module.exports = __webpack_public_path__ + "c1f1ed6f8212f74036c2e8023569a361.png";